import { useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/navigation';
import Cookies from 'js-cookie';
import { useIsUserLoading, useIsAuth } from '@/shared/providers/user-provider/use-user';
import { useCheckAndOpen } from '@/features/auth-management/model/hooks/check-and-open';

const TIMEOUT_DURATION_MS = 20000;

export const AutoViewModalHandler = () => {
  const router = useRouter();
  const isUserLoading = useIsUserLoading();
  const isAuth = useIsAuth();
  const { isCheck } = useCheckAndOpen();
  const [isAutoViewModal, setIsAutoViewModal] = useState(false);

  useEffect(() => {
    setIsAutoViewModal(sessionStorage.getItem('isAutoViewModal') === 'true');
  }, []);

  const hasAuthCookie = Boolean(
    Cookies.get('c_id_reg') ||
    Cookies.get('c_id_auth') ||
    Cookies.get('sessionId')
  );

  const shouldShowModal = useMemo(
    () =>
      isUserLoading === false &&
      !isAuth &&
      !isCheck?.should &&
      !isAutoViewModal &&
      !isCheck?.isAgeCheck,
    [isAutoViewModal, isAuth, isCheck?.should, isCheck?.isAgeCheck, isUserLoading]
  );

  useEffect(() => {
    if (!shouldShowModal) return;

    const timer = setTimeout(() => {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      sessionStorage.setItem('isAutoViewModal', 'true');
      setIsAutoViewModal(true);

      params.set(
        'modal',
        hasAuthCookie ? 'auth' : 'registration'
      );
      url.search = params.toString();
      router.push(url.toString());
    }, TIMEOUT_DURATION_MS);

    return () => clearTimeout(timer);
  }, [router, shouldShowModal, hasAuthCookie]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.removeItem('isAutoViewModal');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (isAuth && isAutoViewModal) {
      sessionStorage.removeItem('isAutoViewModal');
      setIsAutoViewModal(false);
    }
  }, [isAuth, isAutoViewModal]);

  return null;
};

